import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class PolicyService {
    static createNewPolicyCancellationTransaction(
        policyNumber,
        cancellation,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPolicy'),
            'createPolicyCancellationTransaction',
            [policyNumber, cancellation],
            additionalHeaders
        );
    }

    static createNewPolicyChangeTransaction(policyChange, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'createPolicyChangeTransaction', [policyChange], additionalHeaders);
    }

    static getPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicy', [policyNumber], additionalHeaders);
    }

    static getPolicySecure_Ext(policyNumber,termNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicySecure_Ext', [policyNumber,termNumber], additionalHeaders);
    }

    static getPolicyClaims(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyClaims', [policyNumber], additionalHeaders);
    }

    static getRecentlyIssuedPolicies(numberOfDays, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getRecentlyIssuedPolicies', [numberOfDays], additionalHeaders);
    }

    static getRecentlyIssuedPoliciesSecure_Ext(numberOfDays, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getRecentlyIssuedPoliciesSecure_Ext', [numberOfDays], additionalHeaders);
    }

    static getPaginatedRecentlyIssuedPoliciesSecure_Ext(filter, queryParams, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPaginatedRecentlyIssuedPoliciesSecure_Ext', [filter, queryParams], additionalHeaders);
    }

    static getRecentlyViewedPolicies(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getRecentlyViewedPolicies', [], additionalHeaders);
    }

    static getRecentlyViewedPoliciesSecure_Ext(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getRecentlyViewedPoliciesSecure_Ext', [], additionalHeaders);
    }

    static getPolicySummariesForCurrentUser(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicySummariesForCurrentUser', [], additionalHeaders);
    }

    static getPolicyBillingSummaryInfo(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyBillingSummaryInfo', [policyNumber], additionalHeaders);
    }

    static addRecentlyViewedPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'addRecentlyViewedPolicy', [policyNumber], additionalHeaders);
    }

    static addRecentlyViewedPolicySecure_Ext(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'addRecentlyViewedPolicySecure_Ext', [policyNumber], additionalHeaders);
    }

    static getDocumentsForPolicyBySearchSecure_Ext(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getDocumentsForPolicyBySearchSecure_Ext', [data], additionalHeaders);
    }

    static getPolicyTermsForPolicySecure_Ext(policyNumber,accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyTermsForPolicySecure_Ext', [policyNumber,accountNumber], additionalHeaders);
    }

    static getPolicyLossRunDocuments(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyLossRunDocuments', [policyNumber], additionalHeaders);
    }

    static getDocumentsForPolicyByType(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getDocumentsForPolicyByType', [policyNumber], additionalHeaders);
    }

    static getNotesForPolicy(policyNumber, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getNotesForPolicy',
            [policyNumber], additionalHeaders);
    }

    static getDocumentsForPolicy(policyNumber, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getDocumentsForPolicy',
            [policyNumber], additionalHeaders);
    }

    static createNoteForPolicy(params, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'createNoteForPolicy',
            params, additionalHeaders);
    }

    static createNewPolicyRenewalTransaction(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'createPolicyRenewalTransaction', params, additionalHeaders);
    }

    static getPolicyTransactionsForPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyTransactionsForPolicy', [policyNumber], additionalHeaders);
    }

    static getPolicyTransactionsForPolicySecure_Ext(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyTransactionsForPolicySecure_Ext', [policyNumber], additionalHeaders);
    }

    static getPolicyPeriodJobType(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyPeriodJobType', params, additionalHeaders);
    }

    static getPolicySummariesByOffsetSecure_Ext(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicySummariesByOffsetSecure_Ext', [params], additionalHeaders);
    }

    static getPolicySummariesByProdCodeSecure_Ext(params,producerCode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicySummariesByProdCodeSecure_Ext', [params,producerCode], additionalHeaders);
    }

    static getDelinquentPoliciesForCurrentUser(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getDelinquentPoliciesForCurrentUser', [params], additionalHeaders);
    }

    static getPolicyPacket(quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getPolicyPacket', [quoteID], additionalHeaders);
    }

    static getODSPolicySecure_Ext(policyNumber, effectiveDate, expirationDate, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getODSPolicySecure_Ext', [policyNumber, effectiveDate, expirationDate,], additionalHeaders);
    }

    static getODSPolicy(policyNumber, effectiveDate, expirationDate, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPolicy'),
            'getODSPolicy', [policyNumber, effectiveDate, expirationDate,], additionalHeaders);
    }

}
